import React, { useEffect, useState } from "react";
import "./OfflineLinks.css";
import moment from "moment-timezone";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { post } from "../../app/shared/http";
import { withAuth } from "../../app/util/HOC";
import { Modal, ModalFooter } from "react-bootstrap";
import { handleException } from "../../app/util/util";
import { removeUserBookDetails, removeIdbUserBook } from "../../app/models/db";
export function OfflineLinks() {
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const bookVO = JSON.parse(localStorage.getItem('bookVO'));
    const deviceType = localStorage.getItem('deviceType');
    const deviceUid = localStorage.getItem('device_uid');
    const deviceOS = localStorage.getItem('deviceOS');
    const { userId } = userVO;
    const [downlBookDetails, setDownlBookDetails] = useState();
    const [removeBookDetails, setRemoveBookDetails] = useState({});
    const [isShowRemoveLinkPopup, setIsShowRemoveLinkPopup] = useState(false);
    useEffect(() => {
        getOfflineLinks();
        document.title = "View All Offline Links | Aspen Publishing";
    }, []);
    const getOfflineLinks = async () => {
        let fetchedBookVO = await removeIdbUserBook('offlineLinks', { userId });
        fetchedBookVO = fetchedBookVO ? fetchedBookVO : [];
        let filteredBookVO = await handleBookDeviceStatus(fetchedBookVO);
        filteredBookVO = filteredBookVO ? filteredBookVO : fetchedBookVO;
        setDownlBookDetails(filteredBookVO);
    }
    const handleCopyUrl = (offlineDownChapLink) => {
        navigator.clipboard.writeText(offlineDownChapLink);
    }
    const handleRemoveChapterLink = (offlineDownBook) => {
        setIsShowRemoveLinkPopup(true);
        setRemoveBookDetails(offlineDownBook);
    }
    const handleOpenOfflineLink = (linkVal) => {
        window.open(linkVal.target.value, '_blank')
    }
    const handleBookRemove = async () => {
        await removeUserBookDetails(removeBookDetails.uuid, {
            bookISBN: removeBookDetails.bookISBN, userId: userId
        });
        await updateChapterInfoToAdmin({
            "uuid": removeBookDetails.uuid,
            "dateRemoved": moment().format(),
            "bookId": removeBookDetails.bookId,
            "browser": removeBookDetails.browser ? removeBookDetails.browser : "Safari",
        });
    }
    const handleGeneratedDateFormat = (genDate) => {
        let genFinalDate = "";
        const timeZone = moment.tz.guess();
        const genEstDateTime = moment.tz(genDate, "America/New_York");
        const genDateZone = genEstDateTime.clone().tz(timeZone).format('z');
        genFinalDate = (moment(genDate).format("MMMM DD, YYYY hh:mm a ")) + genDateZone;
        return genFinalDate;
    }
    const updateChapterInfoToAdmin = async (bookVO) => {
        let reqData = { "bookVO": bookVO }
        post("/OfflineService/insertOfflineUrlDetail", reqData, "ENV")
            .then(response => response.json())
            .then(data => {
                if (data.status === "false" && data.wkErrorCode) {
                    handleException(data);
                    return false;
                }
                setIsShowRemoveLinkPopup(false);
                getOfflineLinks();
            }).catch(error => {
                console.error("Something went wrong during update book details to admin!", error);
            });
    }
    const handleBookDeviceStatus = async (fetchedBookVoList) => {
        if (!fetchedBookVoList || !fetchedBookVoList.length > 0) { return false; }
        const filteredBookVoList = fetchedBookVoList.map(fetchedBook => {
            const isBookBrowserMatched = fetchedBook.deviceId && (
                deviceOS === fetchedBook.deviceOS &&
                deviceType === fetchedBook.deviceType &&
                deviceUid === fetchedBook.deviceId
            )
            const deviceStatus = isBookBrowserMatched !== undefined ? (isBookBrowserMatched ? "This Device" : "Not this Device") : null;
            return { ...fetchedBook, deviceStatus }
        });
        return filteredBookVoList;
    }
    const getOfflineURL = (url) => {
        if (url.split(".com")[1]) {
            return window.location.origin + url.split(".com")[1]
        }
        
        return window.location.origin + url;
    }
    return (
        <React.Fragment>
            <Header userVO={userVO} bookVO={bookVO} pageName="offlineLinks"></Header>
            <div className="row offline-linkBackGr">
                <div className="col-xl-9 col-lg-9 col-md-11 col-sm-12 col-12 mx-auto text-center offline-linkBase">
                    <div className="offline-linkContainer no-padding">
                        <div className="offline-linkBackGround">
                            <div className="offline-linkDiv">
                                <h5 className="offline-linkOfflineMsg mb-2">All Offline Links</h5>
                                <h6 className="offline-linkOfflineSubMsg">You created the following links to access these titles in your account while offline.</h6>
                            </div>
                        </div>
                    </div>
                    <div className="offline-linkContainer no-padding">
                        <div className="offline-linkBackGround">
                            <div className="offline-linkOtherDiv">
                                {
                                    downlBookDetails ?
                                        downlBookDetails.length > 0 ?
                                            <>
                                                <span className="offline-linkOtherDivMsgTxt"><b>Instructions for using offline links:</b></span>
                                                <p className="offline-linkOtherDivMsgTxt">
                                                    Please save the link as a favorite in the corresponding browser where it was generated. When you're offline, open the browser and click on the link from your favorites. You will be directed to your eBook content.
                                                </p>
                                                {
                                                    downlBookDetails.map((bookDetail, index) => {
                                                        return (
                                                            <div key={index}>
                                                                <p className="offline-linkOtherDivBookTitle mb-2">{bookDetail.bookTitle}</p>
                                                                <div className="input-group pb-2">
                                                                    <input data-testid={`input_${index}`} type="text" value={bookDetail.offlineURL} onClick={(e) => handleOpenOfflineLink(e)} className="form-control rounded-0 text-primary border border-dark offline-linkOtherDivInput" readOnly />
                                                                    <button data-testid={`copy_${index}`} type='button' className='btn btn-primary rounded-0 offline-linkOtherDivCopyBtn pt-1' onClick={() => handleCopyUrl(bookDetail.offlineURL)}>Copy</button>
                                                                </div>
                                                                <p className="offline-linkOtherDivTxt mb-0">
                                                                    {bookDetail.generatedDate ? (`Generated: ` + handleGeneratedDateFormat(bookDetail.generatedDate)) : ""}
                                                                </p>
                                                                <p className="offline-linkOtherDivTxt mb-2">
                                                                    You must use this link
                                                                    {
                                                                        (bookDetail.browser ? ` in ${bookDetail.browser}` : "") +
                                                                        (bookDetail.deviceOS ? ` on ${bookDetail.deviceOS}` : "") +
                                                                        (bookDetail.deviceType ? ` ${bookDetail.deviceType}` : "")
                                                                    }
                                                                    {bookDetail.deviceStatus ? (<b>{' (' + bookDetail.deviceStatus + ')'}</b>) : ""}
                                                                </p>
                                                                <div className='col-12 p-0 mb-3'>
                                                                    <button data-testid={`remove_${index}`} className='btn btn-primary m-auto offline-linkOtherDivBtn' onClick={() => handleRemoveChapterLink(bookDetail)}>Remove Offline Link</button>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </>
                                            : <p className="offline-linkOtherNoBookMsg">You have not created any offline links. Please return to your eBook and use the Offline dropdown menu to save a title for offline use.</p>
                                        : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal size="md" show={isShowRemoveLinkPopup} onHide={() => setIsShowRemoveLinkPopup(true)} centered contentClassName="offline-linkRemovePopup">
                <Modal.Body className="print-content-modals">
                    <div className="offline-linkRemovePopupDiv">
                        <span className="offline-linkRemovePopupTxt">
                            Removing this link means you will no longer be able to use it offline. You can always generate a new offline link for the title. Are you sure you want to remove this offline link from your account?
                        </span>
                    </div>
                </Modal.Body>
                <ModalFooter className='p-0 border-0'>
                    <div className='col-12 text-center no-padding mb-3'>
                        <button className='btn btn-primary mr-2 offline-linkRemovePopupTxtBtn' onClick={() => setIsShowRemoveLinkPopup(false)}>No, Go Back</button>
                        <button className='btn btn-primary m-auto offline-linkRemovePopupTxtBtn' onClick={handleBookRemove}>Yes, Remove Link</button>
                    </div>
                </ModalFooter>
            </Modal>
            <Footer />
        </React.Fragment>
    )
}
export default withAuth(OfflineLinks);